import { defineMessages } from "react-intl";

export const MULTI_PERSON_LIMIT = 100;

const personRelationshipFieldMessages = defineMessages({
  peopleLimitExceeded: {
    id: "createEditActivityModal.field.people.limitExceeded",
    defaultMessage:
      "Activities support up to {limit} {limit, plural, one {person} other {people}}.",
    description:
      "Validation error when user tries to add more than the limit (matches backend v1050)",
  },
});

export default personRelationshipFieldMessages;
